import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import Styles from './FacebookStoryPreview.module.scss'
import { VolumeOn, Pause, MoreDots } from 'blaze-ui/icons'
import { FacebookIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { Edit1 } from 'blaze-ui/icons'
import cx from 'classnames'
import { ReactNode, useState } from 'react'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { DesignChannel } from 'components/NewFileModal/Types'

interface FacebookStoryPreviewProps {
  integration?: FacebookIntegration
  mediaObject?: MediaObject
  showVideoControls?: boolean
  onEdit?: () => void
  containerClassName?: string
  customPreviewContent?: ReactNode
  isActive?: boolean
  isTransitioning?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}

export const FacebookStoryPreview = ({
  integration,
  showVideoControls,
  onEdit,
  containerClassName,
  customPreviewContent,
  mediaObject,
  isActive = true,
  isTransitioning = false,
  isGenerating = false,
  showHoverActionOverlay = false,
  almanacFileKey,
  onClose,
}: FacebookStoryPreviewProps) => {
  const { name, avatar } = integration ? extractProfileInfo(integration) : { name: '', avatar: Silhouette }

  const [imageFailed, setImageFailed] = useState(false)

  return (
    <div className={cx(Styles.container, containerClassName)}>
      <div className={Styles.headerContainer}>
        <div className={Styles.loadingBar}>
          <div className={Styles.progress}></div>
        </div>
        <div className={Styles.header}>
          {imageFailed ? (
            <img className={Styles.avatar} src={Silhouette} alt="Avatar" />
          ) : (
            <img
              className={Styles.avatar}
              src={avatar || Silhouette}
              alt={name || 'Avatar'}
              onError={() => setImageFailed(true)}
            />
          )}
          <span className={Styles.username}>{name}</span>
          <span className={Styles.time}>1h</span>
          {onEdit && (
            <Button variant="tertiary" onPress={onEdit} frontIcon={Edit1}>
              Edit
            </Button>
          )}
          <div className={Styles.headerActions}>
            <VolumeOn />
            <Pause />
            <MoreDots />
          </div>
        </div>
      </div>

      <div className={Styles.content}>
        {customPreviewContent && customPreviewContent}
        {!customPreviewContent && mediaObject && (
          <MediaRenderer
            channel={DesignChannel.FacebookStory}
            mediaObject={mediaObject}
            alt="Story content"
            className={Styles.storyImage}
            showHoverActionOverlay={showHoverActionOverlay}
            almanacFileKey={almanacFileKey}
            showVideoControls={showVideoControls}
            isActive={isActive}
            onClose={onClose}
            isGenerating={isGenerating}
          />
        )}
      </div>
    </div>
  )
}
